import { render, staticRenderFns } from "./OCR.vue?vue&type=template&id=72decfbc&scoped=true&"
import script from "./OCR.vue?vue&type=script&lang=js&"
export * from "./OCR.vue?vue&type=script&lang=js&"
import style0 from "./OCR.vue?vue&type=style&index=0&id=72decfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72decfbc",
  null
  
)

export default component.exports